import './index.less';
import * as React from 'react';
import { Tree, Spin } from '@beehive/components';

export interface SiderProps {
  prefixCls: string;
  isOpen: boolean;
  loading: boolean;
  data: any;
  selectedKeys: string[];
  onChange: Function;
}

class Sider extends React.Component<SiderProps, any> {

  public render() {
    const {
      prefixCls, isOpen, loading, data, selectedKeys,

      onChange,
    } = this.props;

    const className = `${prefixCls}-sider`;

    return (
      <div className={`${className} ${isOpen ? `${className}-open` : `${className}-hide`}`}>
        <Spin.Global spinning={loading} />
        {data && (
          <Tree
            unexpandable
            treeData={data}
            selectedKeys={selectedKeys}
            onSelect={onChange}
          />
        )}
      </div >
    );
  }

}

export default Sider;
